import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

function AddUserAccess() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const navigate = useNavigate();

  // Clear message after 3 seconds
  useEffect(() => {
    let timeoutId;
    if (message.text) {
      timeoutId = setTimeout(() => {
        setMessage({ text: "", type: "" });
      }, 3000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [message.text]);

  const handleGiveAccess = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage({ text: "Please enter an email address", type: "error" });
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("accessToken");
      if (!token) {
        navigate("/");
        return;
      }
      const response = await fetch(`${apiUrl}grant-audit-access`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.status === 200) {
        setMessage({ text: data.message, type: "success" });
        setEmail("");
      } else {
        setMessage({
          text: data.message || "Failed to grant access",
          type: "error",
        });
      }
    } catch (error) {
      setMessage({
        text: error instanceof Error ? error.message : "An error occurred",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="dashboard-title mb-3 d-flex align-items-center gap-3">
        <h1 className="d-flex align-items-center">
          <a
            href="/view-audit-access"
            className="btn btn-outline-secondary btn-sm me-3"
          >
            <i className="bi bi-arrow-left"></i>
          </a>
          Add user
        </h1>
      </div>

      {message.text && (
        <div
          className={`alert alert-${
            message.type === "success" ? "success" : "danger"
          }`}
          role="alert"
        >
          {message.text}
        </div>
      )}

      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">Add User</h5>
        </div>
        <div className="card-body">
          <div className="row clearfix">
            <div className="col-12 col-sm-6">
              <label htmlFor="email" className="col-form-label">
                Email
              </label>
              <input
                type="email"
                name="email"
                id="email"
                className="form-control"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="d-flex gap-1 align-items-center justify-content-between">
            <button
              className="btn btn-primary btn-sm"
              onClick={handleGiveAccess}
              disabled={loading}
            >
              {loading ? "Processing..." : "Give Access"}
            </button>
            <a href="/view-audit-access" className="btn btn-danger">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddUserAccess;
